import ShopService from '@/api/ShopService'

function getShopContactIdByPlatform(platform, contacts) {
  for (let i in contacts) {
    if (contacts[i].platform == platform) {
      return contacts[i].contact_id
    }
  }
  return null
}

function getShopContact(contacts) {
  var email = null,
    tel = null,
    website = null,
    facebook = null,
    youtube = null
  contacts.map(obj => {
    switch (obj.platform) {
      case 'email':
        email = obj.source
        break
      case 'tel':
        tel = obj.source
        break
      case 'website':
        website = obj.source
        break
      case 'facebook':
        facebook = obj.source
        break
      case 'youtube':
        youtube = obj.source
        break
    }
  })
  return {
    'email': email,
    'tel': tel,
    'website': website,
    'facebook': facebook,
    'youtube': youtube,
  }
}

// initial state
const state = {
  shops: [],
  shop: null,
  moduleTransactions: [],
  useLimit: {
    user: 0,
    branch: 0,
    warehouse: 0,
    messageLine: 0,
    email: 0,
  },
  availableToCreate: {
    user: false,
    branch: false,
    warehouse: false,
  },
  discounts: [],
}

// getters
const getters = {
  getShops: state => state.shops,
  getShop: state => state.shop,
  getShopContact: (state) => getShopContact,
  getShopContactIdByPlatform: (state) => (platform, contacts) => {
    for (let i in contacts) {
      if (contacts[i].platform == platform) {
        return contacts[i].contact_id
      }
    }
    return null
  },
  getModuleTransactions: ({ moduleTransactions }) => moduleTransactions,
  getShopUseLimit: state => state.useLimit,
  getShopDiscounts: state => state.discounts,
}

// mutations
const mutations = {
  setShops(state, data) {
    state.shops = data
  },
  setShop(state, data) {
    state.shop = data
  },
  deleteShops(state) {
    state.shops = []
  },
  setState(state, data) {
    for (let key in data) {
      state[key] = data[key]
    }
  },
  clearAvailableToCreate(state) {
    state.availableToCreate.user = false
    state.availableToCreate.branch = false
    state.availableToCreate.warehouse = false
  },
  setAvailableToCreate(state, { type, isAvailable }) {
    state.availableToCreate[type] = isAvailable
  },
  setUseLimit(state, { type, value }) {
    state.useLimit[type] = value
  },
  setDiscounts(state, data) {
    state.discounts = data
  },
}

// actions
const actions = {
  async getShops({ commit }) {
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await ShopService.getAll()

      // stop loading
      this.dispatch('Loading', false)

      let result = response.data

      if (result.success) {
        commit('setShops', result.data)
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
  },
  async getShop({ commit }, data) {
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await ShopService.getSingle(data)

      // stop loading
      this.dispatch('Loading', false)

      let result = response.data

      if (result.success) {
        commit('setShop', result.data)
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
  },
  clearShops({ commit }) {
    return commit('deleteShops')
  },
  async installApp({ commit }, data) {
    try {
      let response = await ShopService.installApp(data)
      let result = response.data
      if (result.success) {
        // update shop and user info
        this.dispatch('setLocalStorageShopInfo')
        this.dispatch('setLocalStorageUserInfo')
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
  },
  async uninstallApp({ commit }, data) {
    try {
      let response = await ShopService.uninstallApp(data)
      let result = response.data
      if (result.success) {
        // update shop and user info
        this.dispatch('setLocalStorageShopInfo')
        this.dispatch('setLocalStorageUserInfo')
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
  },
  async updateShop({ commit }, data) {
    var result
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await ShopService.update(data)

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      // update shop info
      await this.dispatch('setLocalStorageShopInfo')

      if (result.success) {

      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async updateSettings({ commit }, data) {
    var result
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await ShopService.updateSettings(data)

      // update shop info
      await this.dispatch('setLocalStorageShopInfo')

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {

      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async updateSettingsPOS({ commit }, data) {
    var result
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await ShopService.updateSettingsPOS(data)

      // update shop info
      await this.dispatch('setLocalStorageShopInfo')

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {

      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async updateSettingsPurchase({ commit }, data) {
    var result
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await ShopService.updateSettingsPurchase(data)

      // update shop info
      await this.dispatch('setLocalStorageShopInfo')

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {

      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async updateSettingsSale({ commit }, data) {
    var result
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await ShopService.updateSettingsSale(data)

      // update shop info
      await this.dispatch('setLocalStorageShopInfo')

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {

      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async updateSettingsAccount({ commit }, data) {
    var result
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await ShopService.updateSettingsAccount(data)

      // update shop info
      await this.dispatch('setLocalStorageShopInfo')

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {

      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async updateSettingsInventory({ commit }, data) {
    var result
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await ShopService.updateSettingsInventory(data)

      // update shop info
      await this.dispatch('setLocalStorageShopInfo')

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {

      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async updateSettingsPayroll({ commit }, data) {
    var result
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await ShopService.updateSettingsPayroll(data)

      // update shop info
      await this.dispatch('setLocalStorageShopInfo')

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {

      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },
  async updateSettingsExpense({ commit }, data) {
    var result
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await ShopService.updateSettingsExpense(data)

      // update shop info
      await this.dispatch('setLocalStorageShopInfo')

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {

      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },

  async getModuleTransactions({ commit }) {
    var result = null

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await ShopService.getModuleTransactions()

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {
        commit('setState', {
          'moduleTransactions': result.data,
        })
      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },

  clearModuleTransactions({ commit }) {
    commit('setState', {
      'moduleTransactions': [],
    })
  },

  async deleteShopData({ commit }) {
    var result = null

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await ShopService.clearData()

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {

      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },

  async deactivateAccount({ commit }) {
    var result = null

    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await ShopService.deactivateAccount()

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {

      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },

  async getShopUseLimit({ commit }) {
    var result = null
    try {
      this.dispatch('Loading', true)
      this.dispatch('Error', null)
      const response = await ShopService.getUseLimit()
      this.dispatch('Loading', false)
      result = response.data
      if (result.success) {
        commit('setUseLimit', { type: 'user', value: result.data.user_max_count })
        commit('setUseLimit', { type: 'branch', value: result.data.branch_max_count })
        commit('setUseLimit', { type: 'warehouse', value: result.data.warehouse_max_count })
        commit('setUseLimit', { type: 'messageLine', value: result.data.message_line_free_per_month })
        commit('setUseLimit', { type: 'email', value: result.data.email_free_per_month })
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },

  async getShopAvailableToCreate({ commit }, { type = '' }) {
    var result = null
    try {
      commit('clearAvailableToCreate')
      this.dispatch('Loading', true)
      this.dispatch('Error', null)
      const response = await ShopService.getAvailableToCreate(type)
      this.dispatch('Loading', false)
      result = response.data
      if (result.success) {
        const isAvailable = result.data.is_free_available
        commit('setAvailableToCreate', { type, isAvailable })
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },

  async acknowledgeFreeTrialEnded({ commit }) {
    var result
    try {
      // start loading
      this.dispatch('Loading', true)
      // clear error
      this.dispatch('Error', null)

      let response = await ShopService.acknowledgeFreeTrialEnded()

      // update shop info
      await this.dispatch('setLocalStorageShopInfo')

      // stop loading
      this.dispatch('Loading', false)

      result = response.data

      if (result.success) {

      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }
    return result
  },

  async getShopDiscounts({ commit }) {
    var result = null
    try {
      this.dispatch('Loading', true)
      this.dispatch('Error', null)
      const response = await ShopService.getDiscounts()
      this.dispatch('Loading', false)
      result = response.data
      if (result.success) {
        commit('setDiscounts', result.data)
      } else {
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      this.dispatch('Error', e)
    }
    return result
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/Shop.js